import {
  Box,
  Select,
  MenuItem,
  SelectChangeEvent,
  TextField,
} from '@mui/material';
import { useEffect, useState } from 'react';
import countries from '../../Utilis/Country';
import { PhoneNumberUtil } from 'google-libphonenumber';
import { useFormContext } from 'react-hook-form';

type Props = {
  name: string;
  disabled?: boolean;
};

const phoneNumberUtil = PhoneNumberUtil.getInstance();

export const PhoneNrInput = ({ name, disabled }: Props) => {
  const {
    getValues,
    setValue,
    formState: { errors },
  } = useFormContext();

  const [isInitial, setIsInitial] = useState(true);
  const [selectedCountry, setSelectedCountry] = useState<{
    name: string;
    flag: string;
    code: string;
    dial_code: string;
  }>({
    name: 'United States',
    flag: '🇺🇸',
    code: 'US',
    dial_code: '+1',
  });
  const [phoneNumber, setPhoneNumber] = useState('');

  useEffect(() => {
    const initialPhone = getValues()[name];

    if (initialPhone) {
      handleInitialPhone(initialPhone);
    }

    setIsInitial(false);
  }, []);

  useEffect(() => {
    if (!isInitial) {
      const phone = [selectedCountry.dial_code, phoneNumber].join('');

      setValue(name, phone);
    }
  }, [selectedCountry, phoneNumber]);

  const handleInitialPhone = (phone: string) => {
    try {
      const parsedNumber = phoneNumberUtil.parse(phone!);
      const selectedCountryObj = countries.find(
        country => country.dial_code === `+${parsedNumber.getCountryCode()}`
      );
      const number = parsedNumber.getNationalNumber()?.toString()!;

      setSelectedCountry({
        ...selectedCountryObj!,
      });
      setPhoneNumber(number);
    } catch (e) {}
  };

  const handleCountryChange = (e: SelectChangeEvent<string>) => {
    const selectedValue = e.target.value;
    const selectedCountryObj = countries.find(
      country => country.flag === selectedValue
    );
    setSelectedCountry({
      ...selectedCountryObj!,
    });
  };

  const errorMessage: any = !!errors[name]?.message
    ? errors[name]?.message
    : '';

  const isError = !!errorMessage;

  return (
    <Box display={'flex'} gap={'15px'} width={'100%'}>
      <Select
        value={selectedCountry.flag}
        size='small'
        sx={{
          height: 'fit-content',
        }}
        error={isError}
        onChange={handleCountryChange}
        disabled={disabled}
      >
        {countries.map(country => (
          <MenuItem key={country.name} value={country.flag}>
            <span
              style={{
                marginRight: '7px',
              }}
            >
              {country.flag}
            </span>
            {country.dial_code}
          </MenuItem>
        ))}
      </Select>
      <TextField
        type={'tel'}
        placeholder='Phone Number'
        size='small'
        sx={{
          width: '143%',
        }}
        error={isError}
        helperText={errorMessage}
        value={phoneNumber}
        onChange={e => setPhoneNumber(e.target.value)}
        disabled={disabled}
      />
    </Box>
  );
};
